<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">إدخال مستخدم</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "userForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الاسم الاول</label>
                                <input class="form-control" id="validation01" type="text" formControlName="name"
                                [tooltip]="fc.name.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.name.valid && (fc.name.touched)"
                                [class.is-invalid]="fc.name.invalid && (fc.name.touched)"
                         
                                     required
                                     placeholder="الاسم الاول"
                                    containerClass="" />
                            </div>
                            <!-- user name   -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم المستخدم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="userName"
                                [tooltip]="fc.userName.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.userName.valid && (fc.userName.touched)"
                                [class.is-invalid]="fc.userName.invalid && (fc.userName.touched)"
                          
                                     required
                                     placeholder="اسم المستخدم "
                                    containerClass="" />
                            </div>
                          
                                         <!--password-->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> كلمة المرور</label>
                                <input class="form-control" id="validation01" type="password" formControlName="passwordHash"
                                [tooltip]="fc.passwordHash.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.passwordHash.valid && (fc.passwordHash.touched)"
                                [class.is-invalid]="fc.passwordHash.invalid && (fc.passwordHash.touched)"
                               onlyNumbers
                                     required
                                     placeholder="*****"
                                    containerClass="" />
                            </div>
                        </div>                      
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ 
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

